import React from 'react';
import styles from './CoverImage.module.scss';

const CoverImage = () => <div id="cover-image" className={styles.cover} />;

export default CoverImage;
